import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const META = [
  {
    title: "FinPay Mobil",
    tags: ["Flutter", "Node.js", "PostgreSQL"],
    img: "/project-finpay.jpg",
  },
  {
    title: "Atlas Analytics",
    tags: ["Next.js", "TypeScript", "AWS"],
    img: "/project-atlas.jpg",
  },
  {
    title: "GridSense IoT",
    tags: ["Python", "React", "GraphQL"],
    img: "/project-gridsense.jpg",
  },
];

export default function Portfolio() {
  const { t } = useLang();
  return (
    <section id="projeler" className="relative py-24 lg:py-32" data-testid="portfolio-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="glow-badge rounded-full px-4 py-1.5 text-xs font-medium tracking-widest uppercase">
            {t.portfolio.badge}
          </span>
          <h2 className="mt-6 font-heading font-black tracking-tighter text-white text-3xl md:text-5xl max-w-2xl">
            {t.portfolio.title_pre}
            <span className="text-[#5B7FFF]">{t.portfolio.title_accent}</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {META.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group glass-card rounded-2xl overflow-hidden hover:border-[#5B7FFF]/40 transition-colors duration-300"
              data-testid={`portfolio-card-${i}`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#15171C]/80 to-transparent" />
                <span className="absolute top-4 start-4 glow-badge rounded-full px-3 py-1 text-xs font-medium backdrop-blur-md">
                  {t.portfolio.projects[i].category}
                </span>
              </div>
              <div className="p-7">
                <h3 className="font-heading font-bold text-white text-lg tracking-tight">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{t.portfolio.projects[i].desc}</p>
                <div className="mt-5 flex items-center justify-between">
                  <div className="flex flex-wrap gap-2">
                    {p.tags.map((tag) => (
                      <span key={tag} className="text-xs px-2.5 py-1 rounded-full border border-white/10 text-slate-400">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <button
                    className="inline-flex items-center gap-1 text-sm font-semibold text-[#5B7FFF] hover:gap-2 transition-all duration-200"
                    data-testid={`portfolio-incele-${i}`}
                  >
                    {t.portfolio.view} <ArrowUpRight size={16} className="rtl:-scale-x-100" />
                  </button>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
